const MANUFACTURER_FIELDS = `{
	_id
	companyInfo {
		name
		address {
			street
			city
			province
			postalCode
			country
		}
		phone
		fax
		email
		website
		registrationNumber
	}
	accountsPayable {
		contactName
		contactEmail
		contactPhone
	}
}`;

const LOCATION_FIELDS = `{
	_id
	manufacturerId
	name
	description
	yardArea
	address {
		street
		city
		province
		postalCode
		country
	}
}`;

const FACILITY_FIELDS = `{
	_id
	locationId
	name
	description
	type
}`;

const USER_FIELDS = `{
	_id
	name
	email
	role
	linkId
}`;

export const putManufacturerMutation = () => `mutation PutManufacturer($input: ManufacturerInput!, $putManufacturerId: ID) {
	putManufacturer(input: $input, id: $putManufacturerId) ${MANUFACTURER_FIELDS}
}`;

export const postLocationMutation = () => `mutation PostLocation($input: LocationCreateInput!) {
	postLocation(input: $input) ${LOCATION_FIELDS}
}`;

export const putLocationMutation = () => `mutation PutLocation($id: ID!, $input: LocationUpdateInput!) {
	putLocation(id: $id, input: $input) ${LOCATION_FIELDS}
}`;

export const deleteLocationMutation = () => `mutation DeleteLocation($id: ID!) {
	deleteLocation(id: $id)
}`;

export const postFacilityMutation = () => `mutation PostFacility($input: FacilityCreateInput!) {
	postFacility(input: $input) ${FACILITY_FIELDS}
}`;

export const putFacilityMutation = () => `mutation PutFacility($id: ID!, $input: FacilityUpdateInput!) {
	putFacility(id: $id, input: $input) ${FACILITY_FIELDS}
}`;

export const deleteFacilityMutation = () => `mutation DeleteFacility($id: ID!) {
	deleteFacility(id: $id)
}`;

export const registerUserMutation = () => `mutation RegisterUser($name: String!, $email: String!, $role: String!, $linkId: String) {
	register(name: $name, email: $email, role: $role, linkId: $linkId) ${USER_FIELDS}
}`;

export const putUserMutation = () => `mutation PutUser($input: PutUserInput!) {
	putUser(input: $input) ${USER_FIELDS}
}`;

export const deleteUserMutation = () => `mutation DeleteUser($id: ID!) {
	deleteUser(id: $id)
}`;

const MATERIAL_FIELDS = `
	_id
	model
	description
	company
	address
	density
	thickness
	rValue
	nails
`;

export const createMaterialMutation = material => {
    return {
        operationName: "CreateMaterial",
        query        :
            `mutation CreateMaterial($material: MaterialInput!) {
                createMaterial(material: $material) {
                    ${MATERIAL_FIELDS}
                }
            }`,
        variables    : {
            material: material
        }
    }
};

export const updateMaterialMutation = (id, material) => {
    return {
        operationName: "UpdateMaterial",
        query        :
            `mutation UpdateMaterial($id: ID!, $material: MaterialInput!) {
                updateMaterial(id: $id, material: $material) {
                    ${MATERIAL_FIELDS}
                }
            }`,
        variables     : {
            id     : id,
            material: material
        }
    }
};

export const updateMaterialCarbonCharacteristicMutation = characteristics => {
	return {
		operationName: "UpdateMaterialCarbonCharacteristic",
		query        :
			`mutation UpdateMaterialCarbonCharacteristic($characteristics: MaterialCarbonInput!) {
				updateMaterialCarbonCharacteristic(characteristics: $characteristics) {
					_id
				}
			}`,
		variables    : {
			characteristics: characteristics
		}
	}
};

const PROJECT_FIELDS = `{
  _id
  projectId
  projectLang
	projectInfo {
		name
		number
		description
		clientName
		constructionStartDate
		location {
			postalCode
			street
			number
			city
			province
			country
		}
	}
  panelCountEstimator {
    panelConfiguration {
      maxPanelWidth
      maxPanelLength
    }
    selectedWalls {
      wallType
      width
      totalArea
      totalLength
    }
    prefabricatedWallType
    panelEstimation {
      completePanels
      irregularPanels
      numberOfTrucks
      truckDimensions {
        length
        width
        height
      }
      spacerThickness
    }
  }
  carbonImpactEstimator {
    materialtotals {
      area
      volume
      mass
      carbonFootprint
    }
  }
  bracing {
	minimumLength {
	  northSouth
	  eastWest
	}
	validatedWalls {
	  _id
	  name
	  elementId
	  shearNumber
	  orientation
	  length
	  type
	}
	missingLength {
	  northSouth
	  eastWest
	}
  }
}`;

export const createProjectMutation = () => `mutation CreateProject($input: ProjectInput!) {
  createProject(input: $input) ${PROJECT_FIELDS}
}`;

export const updatePanelCountEstimatorMutation = () => `mutation UpdatePanelCountEstimator($projectId: String!, $input: PanelCountEstimatorInput!) {
  updatePanelCountEstimator(projectId: $projectId, input: $input) ${PROJECT_FIELDS}
}`;

export const updatePanelEstimationMutation = () => `mutation UpdatePanelEstimation($projectId: String!, $input: PanelEstimationInput!) {
  updatePanelEstimation(projectId: $projectId, input: $input) ${PROJECT_FIELDS}
}`;

export const updateCarbonImpactMutation = () => `mutation UpdateCarbonImpact($projectId: String!, $input: CarbonImpactInput!) {
  updateCarbonImpact(projectId: $projectId, input: $input) ${PROJECT_FIELDS}
}`;

export const updateBracingResultsMutation = () => `mutation UpdateBracingResults($projectId: String!, $input: BracingInput!) {
  updateBracing(projectId: $projectId, input: $input) ${PROJECT_FIELDS}
}`;

export const updateProjectInfoMutation = () => `mutation UpdateProjectInfo($projectId: String!, $input: ProjectInfoInput!) {
	updateProjectInfo(projectId: $projectId, input: $input) ${PROJECT_FIELDS}
}`;
